// Show an OS-level notification. Prefer the Service Worker path
// (registration.showNotification) because macOS Chrome routes those
// to the native Notification Center correctly; page-side
// `new Notification()` frequently silently fails there.
//
// Returns { via: 'sw' | 'page' } on success. Throws with a specific
// reason otherwise so callers can surface diagnostics.

export async function showOSNotification(title, options = {}) {
  if (!('Notification' in window)) {
    throw new Error('浏览器不支持通知');
  }
  if (Notification.permission !== 'granted') {
    throw new Error('permission-not-granted');
  }
  const opts = { icon: '/favicon.ico', ...options };

  if ('serviceWorker' in navigator) {
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg && typeof reg.showNotification === 'function') {
        await reg.showNotification(title, opts);
        return { via: 'sw' };
      }
    } catch (e) {
      // fall through to legacy page notification
    }
  }

  // Page-side fallback. Not reliable on macOS Chrome, but works elsewhere.
  const n = new Notification(title, opts);
  return { via: 'page', notification: n };
}
